import { Button } from '@unmind/design-system';
import { MicrophoneSlash } from 'icons';
import { hideVisually } from 'polished';
import styled, { css } from 'styled-components';

export const VoiceControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 64px;

  > .hidden {
    ${hideVisually()}
  }
`;

export const DisabledMicrophoneContainer = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 27px;
  padding: 10px;
  background-color: ${({ theme }) =>
    theme.button.primary.disabled.backgroundColor};
  border: none;
`;

export const UnmuteIcon = styled(MicrophoneSlash).attrs(({ theme }) => ({
  primaryColor:
    theme.id === 'dark-theme'
      ? theme.colors.text.primary
      : theme.colors.text.inverse,
  width: 32,
  height: 32,
  pointerEvents: 'none',
}))``;

const sharedButtonStyling = css`
  width: 54px !important;
  height: 54px !important;
  border-radius: 27px !important;
  padding: 10px !important;

  &:focus {
    outline: none;
  }
`;

export const MicrophoneIconButton = styled(Button)`
  &&&.microphone-voice-button.button.only-icon {
    ${sharedButtonStyling}

    svg {
      color: ${({ theme }) => theme.colors.text.inverse};
      width: 32px;
      height: 32px;
    }
  }
`;

export const LeaveVoiceButton = styled(Button)`
  &&&.leave-voice-button.button.only-icon {
    ${sharedButtonStyling}

    svg {
      color: ${({ theme }) => theme.colors.text.inverse};
      width: 20px;
      height: 20px;
      pointer-events: none;
      align-self: center;
    }
  }
`;
